import React from 'react';
import { Card, CardContent, CardDescription, CardHeader } from '../ui/card';
import { Users, Shield, Package, CheckCircle2, Globe, FolderOpen } from 'lucide-react';

const StatsTab = ({ stats, texts }) => {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4" data-testid="stats-tab">
      <Card>
        <CardHeader className="pb-2">
          <CardDescription>{texts.totalUsers}</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="flex items-center gap-2">
            <Users className="h-6 w-6 text-primary" />
            <span className="text-2xl font-bold">{stats?.total_users || 0}</span>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="pb-2">
          <CardDescription>{texts.adminUsers}</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="flex items-center gap-2">
            <Shield className="h-6 w-6 text-accent" />
            <span className="text-2xl font-bold">{stats?.admin_users || 0}</span>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="pb-2">
          <CardDescription>{texts.totalProducts}</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="flex items-center gap-2">
            <Package className="h-6 w-6 text-mint-dark" />
            <span className="text-2xl font-bold">{stats?.total_products?.toLocaleString() || 0}</span>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="pb-2">
          <CardDescription>{texts.availableProducts}</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="flex items-center gap-2">
            <CheckCircle2 className="h-6 w-6 text-success" />
            <span className="text-2xl font-bold">{stats?.available_products?.toLocaleString() || 0}</span>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="pb-2">
          <CardDescription>{texts.uniqueCountries}</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="flex items-center gap-2">
            <Globe className="h-6 w-6 text-primary" />
            <span className="text-2xl font-bold">{stats?.unique_countries || 0}</span>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="pb-2">
          <CardDescription>{texts.uniqueCategories}</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="flex items-center gap-2">
            <FolderOpen className="h-6 w-6 text-secondary" />
            <span className="text-2xl font-bold">{stats?.unique_categories || 0}</span>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default StatsTab;
